import { FavoriteAddress } from '../services/store/auth.dto'

export const DLVModalAction = {
  SELECT_ADDRESS: 'SELECT_ADDRESS',
  ONLY_ADD_FAVORITE: 'ONLY_ADD_FAVORITE',
  ONLY_EDIT_FAVORITE_ADDRESS: 'ONLY_EDIT_FAVORITE_ADDRESS',
} as const

export type DLVModalActionType = (typeof DLVModalAction)[keyof typeof DLVModalAction]

export type DLVModalState =
  | {
      action: 'SELECT_ADDRESS'
      address: undefined
    }
  | {
      action: 'ONLY_ADD_FAVORITE'
      address: undefined
    }
  | {
      action: 'ONLY_EDIT_FAVORITE_ADDRESS'
      address: FavoriteAddress
    }

export const DLVFavoriteKey = {
  work: 'WORK_CODE',
  home: 'HOME_CODE',
} as const
